import { MachineCategoriesApiService } from './_services/machineCategories.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,

  state: {
    machineCategories: [],
  },

  mutations: {
    [MutationTypes.SET_MACHINE_CATEGORIES](state, payload) {
      state.machineCategories = payload;
    },
  },

  actions: {
    async [ActionTypes.GET_MACHINE_CATEGORIES](
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      commit(MutationTypes.SET_MACHINE_CATEGORIES, []);
      commit(
        MutationTypes.SET_MACHINE_CATEGORIES,
        await MachineCategoriesApiService.getMachineCategories({ suffix }),
      );
    },
  },

  getters: {
    sortedMachineCategories: ({ machineCategories }) => machineCategories
      .map(({ name }) => name)
      .sort((a, b) => a.localeCompare(b)),
  },
};
